import Player from '@vimeo/player';


function onYouTubeIframeAPIReady() {
    const youtube_players = document.querySelectorAll( ".yt_player" );

    for (var i = 0; i < youtube_players.length; i++) {
        youtube_players[i].addEventListener( "click", function(event) {
            event.preventDefault();
            //event.stopPropagation();
            let this_player_element = this;
            this.parentElement.classList.add('playing');
            new YT.Player(this, {
                height: '360',
                width: '640',
                videoId: this.dataset.ytid,
                playerVars: {
                    'modestbranding': 1,
                },
                events: {
                    'onReady': function(event){
                        event.target.playVideo();
                        //event.target.parentElement.classList.add('playing');
                        //this_player_element.classList.add('playing');
                    },
                }
            });
        } );
    }
}
window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;


document.addEventListener("DOMContentLoaded", function() {

    const youtube_players = document.querySelectorAll( ".yt_player" );

    if(youtube_players.length > 0) {
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    const vimeo_players = document.querySelectorAll( ".vimeo_player" );

    for (var i = 0; i < vimeo_players.length; i++) {
        vimeo_players[i].addEventListener( "click", function(event) {
            event.preventDefault();
            //event.stopPropagation();
            let this_player_element = this;
            let this_player = new Player(this, {
                id: this.dataset.vimeoid,
                byline: false,
                title: false,
            });

            this_player_element.querySelector('.arrow-wrap').classList.add('hide');
            //this_player_element.querySelector('.loader').classList.add('show');

            this_player.on('loaded', function(){
                //remove play button & cover image
                //this_player_element.querySelector('.loader').classList.add('hide');
                this_player_element.querySelector('.img-cover').classList.add('hide');
                this.play();
                this_player_element.classList.add('playing');
            })
        } );
    } 

});


